<div *ngIf="{account: accountService.account$ | async} as context">
  <ul class="list-unstyled">
    <ng-container *ngFor="let item of menu">
      <li class="py-3" *hasAnyAuthority="item.authorities">
        <a
           class="px-2"
           [href]="item.link"
           [class.active]="router.isActive(item.link, false)"
           mat-button
           [matMenuTriggerFor]="adminMenu"
           [attr.aria-label]="item.label"
           (click)="$event.preventDefault()">
          <mat-icon class="align-middle" [fontSet]="item.iconFont">{{item.iconName}}</mat-icon>
        </a>

        <mat-menu #adminMenu="matMenu">
          <ng-container *ngFor="let child of item.children">
            <ng-container
                          *ngIf="!child.deps || (child.deps?.includes('apiDocsEnabled') && profileInfo?.apiDocsEnabled)">
              <a *hasAnyAuthority="child.authorities"
                 mat-menu-item
                 [routerLink]="child.link"
                 routerLinkActive="active">
                {{child.label}}
              </a>
            </ng-container>
          </ng-container>
        </mat-menu>
      </li>
    </ng-container>
  </ul>
</div>